<!-- <ion-header>
<ion-toolbar>
  <ion-title
    class="cart-title"
    style="text-align: center;font-size: 18px !important;"
    >{{ title | translate }}</ion-title
    >
  </ion-toolbar>
</ion-header> -->

<ion-content style="height: 100%; --padding-start: 5px; --padding-end: 5px">
  <table style="width: 100%;">
    <tr>
      <td>
        <ion-item lines="none" style="--min-height: 20px">
          <ion-label style="padding: 0; margin: 0">
            <h3
              style="padding: 0; margin: 0; font-size: 0.8rem; color: #666666"
              >
              {{ "Checkout.PersonnalInformation" | translate }}
            </h3>
          </ion-label>
          <ion-note slot="end" style="padding: 2px"
            ><span style="color: red">*</span>
            {{ "General.RequiredFields" | translate }}
          </ion-note>
        </ion-item>
        <store-checkout-personal-info-form-desktop #personalInfoForm
          [submitted]="submitted"
          (onSubmit)="onPersonalInfoFormChanged($event)"
        ></store-checkout-personal-info-form-desktop>
      </td>
    </tr>
    <tr>
      <td>
        <ion-item lines="none" style="--min-height: 30px">
          <div
            style="
              display: inline-flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
            "
            >
            <ion-label style="margin: 0px">
              <p class="hidden-sm-up" style="font-size: 0.8rem">
                {{ "Checkout.PaymentInformation" | translate }}
              </p>
              <p class="hidden-xs-up" style="font-size: 0.8rem">
                {{ "Checkout.PaymentInformationslicedup1" | translate }}
              </p>
              <p class="hidden-xs-up" style="font-size: 0.8rem">
                {{ "Checkout.PaymentInformationslicedup2" | translate }}
              </p>
            </ion-label>
            <ion-note slot="end" style="padding: 0px"
              ><span style="color: red"></span>
              <img
                class="hidden-sm-up"
                style="height: 2rem"
                [src]="secureUrl" /><img class="hidden-xs-up" [src]="secureUrl"
              /></ion-note>
            </div>
          </ion-item>
          <ion-item
            lines="none"
            class="important-message"
            style="margin: 0 0 5px 0"
            >
            <ion-icon
              name="alert-circle-outline"
              style="font-size: 20pt; color: orange"
            ></ion-icon>
            <ion-label class="ion-text-wrap" style="padding: 0px; margin: 1px">
              <p style="margin: 0px; font-size: 0.7rem">
                <strong>{{ "General.Important" | translate | uppercase }}</strong
                  >:
                  {{ "Checkout.ImportantMessage" | translate }}
                  {{ "Checkout.MerchandRights" | translate }}
                  {{
                  order._deliveryType == "delivery" &&
                  shippingAddress &&
                  store.strictBillingAddress
                  ? ("Checkout.StrictBillingAddressMessage" | translate)
                  : ""
                  }}
                </p>
              </ion-label>
            </ion-item>
            <!-- <ion-grid style="width: 100%">
            <ion-row>
              <ion-col size="12">
                <h3 style="font-size: 16px; font-weight: bold; margin: 0px">
                  {{ "Checkout.Tip" | translate }}
                </h3>
              </ion-col>
            </ion-row>
          </ion-grid> -->
          <store-checkout-tip-form-desktop
            [subTotal]="subTotal"
            [store]="store"
            [orderType]="order._deliveryType"
            (onSubmit)="onTipChanged($event)"
          ></store-checkout-tip-form-desktop>

          <store-checkout-total-desktop
            (onShipping)="onShippingCalculated($event)"
            (onTotal)="onTotalChanged($event)"
            [store]="store"
            [order]="order"
            [options]="totalOptions"
          ></store-checkout-total-desktop>

          @if (!settingService.configuration.hideGiftProgram) {
            <store-checkout-gift-card-form-desktop
              [freeDelivery]="freeDelivery"
              [subtotal]="subTotal"
              [deliveryPrice]="deliveryPrice"
              [total]="total"
              [storeId]="order.store.id"
              (onSubmit)="onGiftCardChange($event)"
            ></store-checkout-gift-card-form-desktop>
          }

          @if (!settingService.configuration.hideECouponProgram) {
            <app-checkout-coupon-form-desktop
              (closeModal)="searchCoupon($event)"
              (onSubmit)="getDiscountAmount($event)"
              [order]="order"
              [total]="total"
              [subtotal]="subTotal"
              [storeId]="order.store.id"
            ></app-checkout-coupon-form-desktop>
          }
        </td>
      </tr>
      <tr>
        <td>
          
          <!--
          <form action="/charge" method="post" id="payment-form">
            <ion-grid style="padding: 2.5px 5px 0 5px;">
              <ion-row>
                <ion-col style="padding: 0;">
                  <div class="custom-form-group">
                    <input formControlName="firstname" (ionChange)="submit()" id="firstname" class="form-control" type="text"  placeholder="" required>
                    <label for="firstname">{{ 'Checkout.Form.FirstName' | translate }}<span style="color:red;">*</span></label>
                    @if (formFieldValidatorSubmit('firstname', 'required')) {
                      <span style="padding-bottom: 2px;"class="form-errors"
                      >{{ 'Checkout.FormErrors.FirstNameRequired' | translate}}</span>
                    }
                  </div>
                </ion-col>
                <ion-col style="padding: 0;">
                  <div class="custom-form-group">
                    <input formControlName="lastname" (ionChange)="submit()" id="lastname" class="form-control" type="text"  placeholder="" required>
                    <label for="lastname">{{ 'Checkout.Form.LastName' | translate }}<span style="color:red;">*</span></label>
                    @if (formFieldValidatorSubmit('lastname', 'required')) {
                      <span style="padding-bottom: 2px;"class="form-errors"
                      >{{ 'Checkout.FormErrors.LastNameRequired' | translate}}</span>
                    }
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </form>
          -->




          
          @if (store.cloverPaymentInfo != null) {
            <form action="/charge" method="post" id="payment-form">            
              <div style="display: flex; max-height: 35px;">
                <div style="padding: 5px; max-width: 300px;" class="custom-form-group">
                    <div id="card-name" class="card-name"></div>
                    <div class="input-errors" id="card-name-errors" role="alert"></div>
                </div>
                <div style="padding: 5px" class="custom-form-group"></div>
              </div>

              <div style="display: flex; max-height: 35px;">
                  <div style="padding: 5px; max-width: 300px;" class="custom-form-group">
                      <div id="card-number" class="card-number"></div>
                      <div class="input-errors" id="card-number-errors" role="alert"></div>
                  </div>            


                  <div style="padding: 5px; max-width: 100px;" class="custom-form-group">
                      <div id="card-date" class="field third-width"></div>
                      <div class="input-errors" id="card-date-errors" role="alert"></div>
                  </div>

                  <div style="padding: 5px; max-width: 125px;" class="custom-form-group">
                      <div id="card-cvv" class="field third-width"></div>
                      <div class="input-errors" id="card-cvv-errors" role="alert"></div>
                  </div>
              </div>

              <div style="display: flex; max-height: 35px;">              
                  <div style="padding: 5px; max-width: 125px;" class="custom-form-group">
                      <div id="card-postal-code" class="field third-width"></div>
                      <div class="input-errors" id="card-postal-code-errors" role="alert"></div>
                  </div>
              </div>
              <div style="display: flex; max-height: 35px; margin-bottom: 20px;">  
                <div style="display: flex; justify-content: center; margin-top: 5px;" class="button-container">
                    <ion-button type="submit" [disabled]="cloverTokenId != null"  id="payment-request-button" style="margin-bottom: 20px">{{ "Checkout.SubmitCard" | translate | uppercase }}</ion-button>
                </div>
              </div>      
              <div id="card-response" role="alert"></div>                   
          </form>
        }
        

        @if ((!auth.isAuthenticated || (store.paymentRestriction && store.paymentRestriction.use3DSecure)) && !isGiftCardFullyCover && store.cloverPaymentInfo == null) {
          <shared-credit-card-form-desktop
            [submitted]="submitted"
            (onSubmit)="onGuestCreditCardChanged($event)"
          ></shared-credit-card-form-desktop>
          <shared-address-desktop
            [isReservation]="false"
            [skipProvinceValidation]="false"
            [submitted]="submitted"
            (onChange)="onBillingAddressChanged($event)"
            placeHolder="{{ 'CreditCard.BillingAddress' | translate }}"
            [desktop]="true"
          ></shared-address-desktop>
        }
        </td>
      </tr>
      <tr>
        <td *ngIf="store.cloverPaymentInfo == null || (store.cloverPaymentInfo != null && cloverTokenId != null)">
          @if (auth.isAuthenticated && !isGiftCardFullyCover && (!store.paymentRestriction || !store.paymentRestriction.use3DSecure) && store.cloverPaymentInfo == null) {
            <account-credit-card-checkout
              (onCardSelected)="onMemberCreditCardChanged($event)"
              [submitted]="submitted"
              [storeId]="store.id"
            ></account-credit-card-checkout>
          }
          <ion-item class="order-type-row" style="--min-height: 27px">
            <ion-label class="ion-text-wrap" style="width: 100%; margin: 2px">
              @if (order._deliveryType == 'delivery' && shippingAddress) {
                <p
                  class="bigger-ion-text"
                  style="font-size: 0.7rem"
                  >
                  {{ "Checkout.Delivery" | translate }} :
                  <span class="inline-block"
                    >{{ shippingAddress.streetNumber }}
                    {{ shippingAddress.street }}, {{ shippingAddress.city }},
                    {{ shippingAddress.postalCode }}</span
                    >
                  </p>
                }
                @if (order._deliveryType == 'shipping' && shippingAddress) {
                  <p
                    class="bigger-ion-text"
                    style="font-size: 0.7rem"
                    >
                    {{ "Checkout.Shipping" | translate }} :
                    <span class="inline-block"
                      >{{ shippingAddress.streetNumber }}
                      {{ shippingAddress.street }}, {{ shippingAddress.city }},
                      {{ shippingAddress.postalCode }}</span
                      >
                    </p>
                  }
                  @if (order._deliveryType == 'pickup' && store) {
                    <p
                      class="bigger-ion-text"
                      style="font-size: 0.7rem"
                      >
                      {{ "Checkout.Pickup" | translate }} : {{ store.displayName }} -
                      <span class="inline-block"
                        >{{ store.address.streetNumber }} {{ store.address.street }},
                        {{ store.address.city }}, {{ store.address.postalCode }}</span
                        >
                      </p>
                    }
                    @if (order._deliveryType == 'seat' && store && order._seatInfo) {
                      <p class="bigger-ion-text">
                        {{ 'Checkout.Seat' | translate }} : {{ store.displayName}}<br/>
                        <span class="inline-block">{{ 'Checkout.Section' | translate }} {{ order._seatInfo.section }} - {{ 'Checkout.Row' | translate }} {{ order._seatInfo.row }} - {{ 'Checkout.Seat' | translate }} #{{ order._seatInfo.seatNumber }}</span>
                      </p>
                    }
                  </ion-label>
                </ion-item>

                <!-- <ion-item> Put that inside a component
                <ion-label  class="ion-text-wrap">
                  {{ 'Checkout.SendNotification' | translate }}
                </ion-label>
                <ion-checkbox  (ionChange)="submitSendNotification()" id="sendNotification" color="primary" slot="start" checked></ion-checkbox>
              </ion-item> -->
              @if (isDelivery && store.isDoorDashDrive) {
                <store-checkout-doordash-drive-form
                  (onSubmit)="onSendNotificationChanged($event)"
                  >
                </store-checkout-doordash-drive-form>
              }
              @if (isDelivery && store.isUberDirect) {
                <checkout-uber-direct-form
                  [hasAlcohol]="hasAlcohol"
                  (onSubmit)="onDeliveryOptionChanged($event)">
                </checkout-uber-direct-form>
              }
              <store-checkout-order-note-form-desktop
                [isDelivery]="isDelivery"
                (onSubmit)="onCheckoutNoteChange($event)"
              ></store-checkout-order-note-form-desktop>
              @if (hasAlcohol) {
                <div class="alcohol-notice">
                  {{ "Checkout.AlcoholItemNoticeText" | translate }}
                </div>
              }

              <!--
              <store-checkout-total-desktop
                (onShipping)="onShippingCalculated($event)"
                (onTotal)="onTotalChanged($event)"
                [store]="store"
                [order]="order"
                [options]="totalOptions"
              ></store-checkout-total-desktop>
              -->

              <!--
              <div *ngIf="underMinimumOrderValue()" class="alcohol-notice">
                {{ "Checkout.UnderMinimumOrderValue" | translate }}{{ this.settingService.configuration.minDeliveryOrderAmount }}{{ "$" }}
              </div>
              -->



              @if (store.askUtensils) {
                <div>
                  <ion-item>
                    <ion-checkbox style="margin-left: 10px;" (ionChange)="onUtensilsChange($event)" color="primary" slot="start"></ion-checkbox>
                    <ion-label style="margin: 0; font-size: .7rem; margin-left: 20px;">{{ "Checkout.AskUtensils" | translate }}</ion-label>
                  </ion-item>
                </div>
              }
              <store-checkout-terms-agreement-form-desktop
                (onSubmit)="onTermsAgreementChanged($event)"
              ></store-checkout-terms-agreement-form-desktop>
              <!--[disabled]="!isFormValid"-->
              <!--<ion-item>
              <ion-label class="ion-text-wrap">
                <p style="color:red;"> {{ 'General.TemporaryOutOfService' | translate }}</p>
              </ion-label>
            </ion-item>-->

            <ion-button
              expand="block"
              [disabled]=" clickedSubmitted || !termsAgreement || (termsAgreement && !termsAgreement.agreement) || underMinimumOrderValue() "
              (click)="pay()">{{ "General.Pay" | translate }}</ion-button>
            </td>
          </tr>
        </table>
      </ion-content>
